import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class StorageCondition extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.itemMasterServices = new ItemMasterServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      tableStatus: "",
      storageConditionList: [],
      storageConditionDetails: {
        storageCondition: "",
      },
    };
  }

  componentDidMount() {
    this.getAllStorageConditions();
  }

  getAllStorageConditions = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllStorageConditions().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { storageConditionList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  addEditStorageConditions = () => {
    if (this.state.storageConditionDetails.storageCondition !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.storageConditionDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices
          .addEditStorageConditions(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.resetForm();
              this.SwalServices.Success(response.Message);
              this.setState({ isLoading: false })
            } else {
              this.SwalServices.Error(
                response.Message
              );
              this.setState({ isLoading: false })
            }
          });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.storageConditionDetails;
    details.storageCondition = "";
    this.setState({ storageConditionDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllStorageConditions();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.storageConditionDetails;
    details[name] = value.toUpperCase();
    this.setState({ storageConditionDetails: details });
  };

  getStorageConditionById = (group) => {
    let details = this.state.storageConditionDetails;
    details.storageCondition = group.storageCondition;
    this.setState({ storageConditionDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteStorageConditionById = (id) => {
    this.itemMasterServices.deleteStorageConditionById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllStorageConditions();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp w-[50%] !mb-3.5">
              <label>Storage Condition</label>
              <input
                className="inputFocus"
                type="text"
                id="storageCondition"
                name="storageCondition"
                autoComplete="off"
                value={this.state.storageConditionDetails.storageCondition}
                onChange={(event) =>
                  this.handleChange(event, "storageCondition")
                }
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditStorageConditions()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditStorageConditions()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Storage Condition</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.storageConditionList &&
                    this.state.storageConditionList.length > 0 ?
                    this.state.storageConditionList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.storageCondition}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getStorageConditionById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() =>
                              this.deleteStorageConditionById(group._id)
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.storageConditionList &&
                      this.state.storageConditionList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.storageConditionList &&
                      this.state.storageConditionList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StorageCondition;
